import styled from 'styled-components';

export const Container = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${(props) => props.theme.colors.white};
  cursor: wait;

  & > div {
    width: 15rem;

    @media (min-width: ${(props) => props.theme.breakpoints.mobileL}) {
      width: 20rem;
    }

    img {
      display: block;
      width: 90%;
      margin: 15px auto;
    }
  }
`;

export const Paragraph = styled.p`
  text-align: center;
  small {
    color: ${(props) => props.theme.colors.blueGerdau};
  }
`;

export const LoadingBar = styled.div`
  position: relative;
  height: 5px;
  width: 90%;
  background-color: ${(props) => props.theme.colors.gray2};
  margin: 15px auto;

  & > div {
    position: absolute;
    height: 5px;
    top: 0px;
    left: 0px;
    width: 50px;
    background-color: ${(props) => props.theme.colors.blueGerdau};
    animation: bar 3s ease-in-out infinite;
  }

  @keyframes bar {
    from {
      left: 0;
      transform: translateX(0);
    }
    50% {
      left: 100%;
      transform: translateX(-100%);
    }
    to {
      left: 0;
      transform: translateX(0);
    }
  }
`;
